import { RefObject, useEffect } from 'react';

interface UseExpandedWindowInteractionTrackingParams {
  isMouseButtonDownRef: RefObject<boolean>;
  normalizeExpandedDatesWindow: () => boolean;
}

export const useExpandedWindowInteractionTracking = ({
  isMouseButtonDownRef,
  normalizeExpandedDatesWindow,
}: UseExpandedWindowInteractionTrackingParams): void => {
  useEffect(() => {
    const handleMouseDown = () => {
      isMouseButtonDownRef.current = true;
    };

    const handleMouseMove = (event: MouseEvent) => {
      if (event.buttons !== 0) {
        isMouseButtonDownRef.current = true;
      }
    };

    const handlePointerMove = (event: PointerEvent) => {
      if (event.buttons !== 0) {
        isMouseButtonDownRef.current = true;
      }
    };

    const finalizeExpandedInteraction = () => {
      isMouseButtonDownRef.current = false;
      normalizeExpandedDatesWindow();
    };

    window.addEventListener('mousedown', handleMouseDown, true);
    window.addEventListener('mousemove', handleMouseMove, true);
    window.addEventListener('mouseup', finalizeExpandedInteraction, true);
    window.addEventListener('pointermove', handlePointerMove, true);
    window.addEventListener('pointerup', finalizeExpandedInteraction, true);
    window.addEventListener('pointercancel', finalizeExpandedInteraction, true);
    window.addEventListener('blur', finalizeExpandedInteraction);

    return () => {
      window.removeEventListener('mousedown', handleMouseDown, true);
      window.removeEventListener('mousemove', handleMouseMove, true);
      window.removeEventListener('mouseup', finalizeExpandedInteraction, true);
      window.removeEventListener('pointermove', handlePointerMove, true);
      window.removeEventListener('pointerup', finalizeExpandedInteraction, true);
      window.removeEventListener('pointercancel', finalizeExpandedInteraction, true);
      window.removeEventListener('blur', finalizeExpandedInteraction);
    };
  }, [isMouseButtonDownRef, normalizeExpandedDatesWindow]);
};
